<template>
  <section>
    <v-container>
      <page-title title="客戶管理" />
    </v-container>
    <liff-list :listKey="listKey">
      <template v-slot:list-data-title>
        <h4 class="my-2">{{ title }}</h4>
        <v-divider></v-divider>
      </template>
    </liff-list>
  </section>
</template>

<script lang="babel" type="text/babel">
import listMixin from "@/components/list/mixins/listMixin.js"
import listConfig from "./clientListConfig"

export default {
  mixins: [listMixin],
  components: {

  },
  data: () => ({
    listKey: 'liff-client-list',
    meta: {},
  }),
  computed: {
    batchConfig() {
      return this.$store.getters[`list/${this.listKey}/batchConfig`]
    },
    providerId() {
      return this.$store.getters[`member/providerId`]
    },
    listFilter() {
      return this.$store.getters[`list/${this.listKey}/filter`]
    },
    status() {
      if(!this.listFilter) return null
      return this.listFilter.status
    },
    title() {
      if(!this.status) return ''
      return this.$t(`provider.status.${this.status}`)
    },
    listData() {
      return this.$store.getters[`list/${this.listKey}/data`]
    },
  },
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.providerApi.clientIndex(this.providerId, params)
    },
    getListConfig() {
      return listConfig
    },
    async batchApi(targets, column, value) {
      const params = {
        store_ids: targets,
        status: value
      }
      return await this.$api.collection.providerApi.batchStatus(this.providerId, params)
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
